// FHIR
import { Device } from "fhir/r5";
// Types
import { InformationSystemLink, InformationSystemNode } from "./InformationSystemMapping.types";

function getReferenceId(reference?: string): string | undefined {
    return reference?.split("/").pop();
}

function getGatewayReference(device: Device): string | undefined {
    const gateway = (device as any).gateway;

    if (!gateway) {
        return undefined;
    }

    const gatewayValue = Array.isArray(gateway) ? gateway.at(0) : gateway;

    if (typeof gatewayValue === "string") {
        return gatewayValue;
    }

    if (typeof gatewayValue.reference === "string") {
        return gatewayValue.reference;
    }

    if (typeof gatewayValue?.reference?.reference === "string") {
        return gatewayValue.reference.reference;
    }

    if (typeof gatewayValue?.valueReference?.reference === "string") {
        return gatewayValue.valueReference.reference;
    }

    return undefined;
}

function getDeviceName(device: Device): string {
    return device.name?.at(0)?.value ?? device.id ?? "Unknown application";
}

function getDeviceVersion(device: Device): string | undefined {
    return device.version?.find(
        (version: any) => version.type?.coding?.some((coding: any) => coding.code === "lastRelease")
    )?.value ?? device.version?.at(0)?.value;
}

export function mapDeviceToInformationSystemNode(device: Device): InformationSystemNode {
    return {
        id: device.id ?? getDeviceName(device),
        name: getDeviceName(device),
        category: device.category?.at(0)?.coding?.at(0)?.code,
        status: device.availabilityStatus?.coding?.at(0)?.code,
        version: getDeviceVersion(device),
        endpointLabel: device.endpoint?.at(0)?.display,
        endpointUrl: device.contact?.at(0)?.value,
        raw: device,
    };
}

export function mapDeviceGatewayLinks(device: Device): InformationSystemLink[] {
    const sourceDeviceId = device.id;
    const targetDeviceId = getReferenceId(getGatewayReference(device));

    if (!sourceDeviceId || !targetDeviceId) {
        return [];
    }

    return [
        {
            id: `${sourceDeviceId}-gateway-${targetDeviceId}`,
            sourceDeviceId,
            targetDeviceId,
            type: "gateway",
            label: "gateway",
        },
    ];
}
